import React from 'react';
import FormInput from '../forms/FormInput';
import Button from '../common/Button';
import Card from '../common/Card';
import { useForm } from '../../hooks/useForm';
import { validators } from '../../utils/validators';
import { theme } from '../../config/theme';

const ProfileForm = ({ user, onSubmit, loading }) => {
  const { values, errors, touched, handleChange, handleBlur, validate, setValues } = useForm(
    {
      first_name: user?.first_name || '',
      last_name: user?.last_name || '',
      email: user?.email || '',
      phone: user?.phone || '',
    },
    {
      first_name: (value) => validators.name(value, 'First name'),
      last_name: (value) => validators.name(value, 'Last name'),
      email: (value) => validators.email(value),
      phone: (value) => validators.phone(value, false),
    }
  );

  React.useEffect(() => {
    if (user) {
      setValues({
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        email: user.email || '',
        phone: user.phone || '',
      });
    }
  }, [user, setValues]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }
    await onSubmit(values);
  };

  return (
    <Card padding="xl">
      <h2 style={{
        fontSize: theme.typography.fontSize.xl,
        fontWeight: theme.typography.fontWeight.semibold,
        marginBottom: theme.spacing.xl,
      }}>
        Personal Information
      </h2>

      <form onSubmit={handleSubmit}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: theme.spacing.md,
        }}>
          <FormInput
            label="First Name"
            name="first_name"
            value={values.first_name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.first_name}
            touched={touched.first_name}
            required
          />
          <FormInput
            label="Last Name"
            name="last_name"
            value={values.last_name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.last_name}
            touched={touched.last_name}
            required
          />
        </div>

        <FormInput
          label="Email Address"
          name="email"
          type="email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.email}
          touched={touched.email}
          required
          disabled
          helperText="Email cannot be changed"
        />

        <FormInput
          label="Phone Number"
          name="phone"
          type="tel"
          value={values.phone}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.phone}
          touched={touched.phone}
          placeholder="9876543210"
        />

        <Button type="submit" loading={loading} disabled={loading}>
          Save Changes
        </Button>
      </form>
    </Card>
  );
};

export default ProfileForm;